export default {
  headerContent: {
    title: 'HDI Sigorta İş Yeri Sigortası Hesaplama',
    slogan: "İş Yeri Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'İŞ YERİ SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'HDI Sigorta İş Yeri Sigortası',
    description: {
      title: 'HDI Sigorta İş Yeri (Paket) Sigortası Nedir? ',
      content: [
        'İşletmede oluşacak kaza ve hasarlar sonucunda meydana gelen maddi kayıplar Hdi Sigorta tarafında güvence altına almaktadır.',
        'Hdi Sigorta iş yeri sigortası, iş yerinde oluşabilecek infilak ve yangın riskler başta olmak üzere bir çok riske karşı koruma sağlamaktadır. ',
        'Hdi sigorta sağlamış olduğu bu koruma ile işletmeyi uğrayacağı zarardan kurtararak işletme sermayesini güvence altına almaktadır.'
      ]
    },
    subContent: {
      title: 'HDI Sigorta İş Yeri (Paket) Sigortası Teminatları Nedir?',
      content: [
        {
          paragraph:
            'HDI sigorta teminatları ana ve ek olmak üzere 2 ye ayrılmaktadır.',
          subList: null
        },
        {
          paragraph: '<strong><em><u>Ana teminatlar:</u></em></strong>',
          subList: [
            'Yangın, ',
            'Yıldırım,',
            'İnfilak',
            'Yangın mali sorumluluk'
          ]
        },
        {
          paragraph: '<strong><em><u>Ek teminatlar:</u></em></strong>',
          subList: [
            'Acil Sağlık Hizmetleri',
            'Çalışanlara Ait Eşyalar',
            'Deprem',
            'Dolu',
            'Duman',
            'Elektronik Cihaz',
            'Ferdi Kaza',
            'Grev, Lokavt, Kargaşalık, Halk Hareketleri, ',
            'Hukuksal Koruma',
            'İş Durması',
            'Makine Kırılması',
            'Nakliyat Emtea Sigortası',
            'Sel Ve Su Baskını',
            'Terör',
            'İşveren Mali Sorumluluk',
            'Üçüncü Şahıs Mali Sorumluluk',
            'Yer Kayması'
          ]
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'İş Yeri Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'İş Yeri Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'İş Yeri Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'İş Yeri Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'İş Yeri Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'HDI Sigorta İş Yeri Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: []
}
